module.exports = __webpack_public_path__ + "img/incoming-call.6bf95408.svg";